<template>
    <div>
        <button class="btn btn-default btn-xs" @click="processCampaignAssets" :class="status">{{ status }} <i class="zmdi zmdi-refresh"></i></button>
        <small v-if="(status === 'crawling' || status === 'processing_prompts') && progress_detail" class="text-muted d-block">{{ progress_detail }}</small>
    </div>
</template>

<script>
    export default {
        props: ['campaign'],
        data() {
            return {
                status: this.campaign.status,
                processing: false,
                progress_detail: '',
                error_message: ''
            }
        },
        created() {
            Echo.private('campaign-status').listen('.crawler-status', (e) => {
                if (e && this.campaign.id === e.campaign_id) {
                    this.status = e.status;
                    if (e.status === 'crawling' && e.progress) {
                        this.progress_detail = e.progress.engine
                            + ' — ' + e.progress.keyword
                            + ' (' + e.progress.keywords_completed + '/' + e.progress.keywords_total + ')';
                    } else if (e.status === 'processing_prompts' && e.progress) {
                        var detail = 'AI: ' + (e.progress.prompt || '');
                        if (e.progress.provider) {
                            detail += ' via ' + e.progress.provider;
                        }
                        this.progress_detail = detail;
                    } else {
                        this.progress_detail = '';
                    }
                }
            });
        },
        methods: {
            processCampaignAssets( event ) {
                event.preventDefault();
                if (this.processing || this.status === 'crawling' || this.status === 'processing_prompts') {
                    return;
                }

                var previousStatus = this.status;
                this.processing = true;
                this.status = 'crawling';
                this.progress_detail = '';

                axios.put( '/api/search_results/' + this.campaign.id + '/process' )
                .then( (response) => {
                    if (response.data && response.data.status) {
                        this.status = response.data.status;
                    }
                    this.processing = false;
                })
                .catch( (error) => {
                    console.log(error.response);
                    this.status = previousStatus;
                    this.processing = false;
                    var response = error.response || {};
                    var data = response.data || {};
                    this.error_message = "Asset processing failed w/ error: " + (data.message || data.error || error.message);
                });
            }
        }
    }
</script>
